import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'search'
})
export class SearchPipe implements PipeTransform {

    constructor() { }
    transform(items: any[], search: string = '', action: string = ""): any[] {

        if (items && search) {
            switch (action) {
                case 'sessions':
                    if (!items) return null;
                    if (!search) return items;
                    items = this.sessionFilter(items, search);
                    break;
            }
        }
        return (items || []);
    }


    sessionFilter(items: any[], search: string): any[] {
        let filterItm = items;
        try {
            search = search?.toLocaleLowerCase();
            filterItm = items.filter(x => {
                if (x && (x.name && x.name?.toLocaleLowerCase().includes(search)
                    || (x.guests && x.guests.some(g => g.name?.toLocaleLowerCase().includes(search)))
                )) {
                    return x;
                }
            })
            
        } catch (error) { }
        return filterItm;  
        // return items.filter(x => x.name.toLocaleLowerCase() === search.toLocaleLowerCase()
        //     || x.guests.some(g => g.name.toLocaleLowerCase() === search.toLocaleLowerCase()));

    }

}  